module.exports = __webpack_public_path__ + "media/images/lb/287-d307e4923360771850ca09817c9412fe.svg";